import { twMerge } from 'tailwind-merge'
import React, { PropsWithChildren } from 'react'
import { ArrowRightAlt, Close } from '@material-ui/icons'

import { ActionButton, Props as ActionButtonProps } from 'ui-v2'

type Props = {
  classes?: {
    root?: string
  }
  submitButton?: PropsWithChildren<ActionButtonProps>
  cancelButton?: PropsWithChildren<ActionButtonProps>
  deleteButton?: PropsWithChildren<ActionButtonProps>
}

export const ActionButtonGroup = ({ classes, submitButton, cancelButton, deleteButton }: Props) => (
  <div className={twMerge('flex justify-end gap-x-6 md:gap-x-3', classes?.root)}>
    {deleteButton && (
      <ActionButton color="white" classes={{ root: 'mr-auto' }} {...deleteButton}>
        {deleteButton?.children || 'Delete'}
      </ActionButton>
    )}
    {cancelButton && (
      <ActionButton color="white" Icon={<Close />} {...cancelButton}>
        {cancelButton?.children || 'Cancel'}
      </ActionButton>
    )}
    <ActionButton color="blue" Icon={<ArrowRightAlt />} {...submitButton}>
      {submitButton?.children || 'Submit'}{' '}
    </ActionButton>
  </div>
)
